import dayjs from "dayjs";
import { useEffect } from "react";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../store/slices/UI";
import Date from "../../../../../UI/GeneralPurpose/Date";

const UIText = {
  "es-CL": { label: "Hasta:" },
  "en-US": { label: "Until date" },
};

export const DateUntilId = "mail-until-date";
const id = DateUntilId;

const UntilDate = () => {
  const { dispatch, UI } = useUIBp();
  const filter = UI.filter ?? "";

  useEffect(() => {
    const untilMatch = filter.match(/\bendDate:(\d+-\d+-\d+)\b/);
    const untilValue = untilMatch ? untilMatch[1] : "";

    if (untilValue) {
      dispatch(
        UIactions.setField({ id, value: dayjs(untilValue, "DD-MM-YYYY") })
      );
    }
  }, [dispatch, filter]);

  return (
    <Date
      emptyStart
      clearOnUnmount
      {...{ id, UIText, size: 6 }}
    />
  );
};

export default UntilDate;
